import { getRaffleRelationships } from "@bkry/bowline-redux/raffles";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Table } from "reactstrap";
import RaffleWinnerRow from "./utils/RaffleWinnerRow";
/**
 * RaffleWinners
 */
const RaffleWinners = (props, context) => {
  const { raffleId } = props;

  const raffleRelationships = useSelector((state) =>
    getRaffleRelationships(state, raffleId)
  );

  return (
    <div>
      <Table striped borderless responsive>
        <thead>
          <tr>
            <th>{context.t("Position")}</th>
            <th className="w-100">{context.t("Wallet")}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {raffleRelationships?.winning_raffle_registrations?.data?.map(
            (winner) => (
              <RaffleWinnerRow
                raffleRegistrationId={winner.id}
                key={winner.id}
              />
            )
          )}
        </tbody>
      </Table>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
RaffleWinners.contextTypes = {
  t: PropTypes.func,
};

RaffleWinners.propTypes = {
  raffleId: PropTypes.string.isRequired,
};

/** export the component as redux connected component */
export default RaffleWinners;
